import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withHandlers from 'recompose/withHandlers';
import { connect } from 'react-redux';
import lifecycle from 'recompose/lifecycle';
import CanvasDrawerContent from './CanvasDrawerContent';
import withProductCustomisation from '../../../hocs/withProductCustomisation';
import { withModel } from '../../../data-providers/model';
import withMedia from 'src/client/js/view/hocs/withMediaQueries';
import { replaceCanvasText } from '../../Canvas/helpers';
import { getDrawerId } from '../helpers';
import { getAppScrollPos } from '../../../../store/selectors/app/index';
import { setOpenOverlay, setCloseOverlay } from '../../../../store/actions/app';


const enhance = compose(
  withMedia,
  withProductCustomisation,
  withModel,
  connect((state, props) => ({
    currentScrollPos: getAppScrollPos(state),
  }), dispatch => ({
    openOverlay: scrollPos => dispatch(setOpenOverlay(scrollPos)),
    closeOverlay: () => dispatch(setCloseOverlay()),
  })),
  withProps(props => {
    const drawerId = getDrawerId(props.drawer, props.index);
    return {
      drawerId,
      isOpen: drawerId === props.activeDrawer,
      form: props.form ? { ...props.form, cta: props.drawer.primary.cta } : {},
      title: replaceCanvasText(props.title, props),
      description: replaceCanvasText(props.description, props),
      isModal: !props.media.desktopUp,
    };
  }),
  withHandlers({
    onCancel: props => () => props.onToggleDrawer(),
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      const props = this.props;

      if (props.isModal) {
        if (props.isOpen && props.isOpen !== prevProps.isOpen) {
          prevProps.openOverlay(window.scrollY);
        } else if (!props.isOpen && props.isOpen !== prevProps.isOpen) {
          prevProps.closeOverlay();
        }
      }
    }
  })
);

export default enhance(CanvasDrawerContent);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CanvasDrawers/CanvasDrawerContent/index.js